import React from 'react';
import { MapPin, Download } from 'lucide-react';
import { guessAudioMime } from './chatUtils';

function MessageBubble({ message, mediaType }) {
  const isOutbound = message.direction === 'outbound';
  
  const bubbleClasses = `
    max-w-[78%] rounded-2xl p-3.5 shadow-md mb-3
    transition-all duration-200 hover:shadow-lg
    ${isOutbound 
      ? 'bg-gradient-to-br from-brand-primary to-brand-primary/90 text-white rounded-tr-md ml-auto' 
      : 'bg-white text-slate-900 rounded-tl-md mr-auto border border-slate-200'
    }
  `;

  const containerClasses = `
    flex animate-in fade-in slide-in-from-bottom-2 duration-300
    ${isOutbound ? 'justify-end' : 'justify-start'}
  `;

  return (
    <div className={containerClasses}>
      <div className={bubbleClasses}>
        {/* Content based on media type */}
        {mediaType === 'location' ? (
          <div>
            <div className="flex items-center gap-2 font-bold mb-3 font-montserrat text-brand-gold">
              <MapPin className="w-5 h-5" />
              Ubicación compartida
            </div>
            <a
              href={`https://www.google.com/maps?q=${message.latitude},${message.longitude}`}
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center gap-2 text-sm px-3 py-2 rounded-lg transition-colors font-montserrat ${
                isOutbound 
                  ? 'bg-white/20 hover:bg-white/30 text-white' 
                  : 'bg-slate-100 hover:bg-slate-200 text-slate-900'
              }`}
            >
              <MapPin className="w-4 h-4" />
              {message.content || `${message.latitude}, ${message.longitude}`}
            </a>
          </div>
        ) : mediaType === 'audio' ? (
          <div>
            <div className="flex items-center gap-2 font-bold mb-3 text-sm font-montserrat">
              🎤 Mensaje de voz
            </div>
            <audio
              controls
              preload="metadata"
              className="w-full mb-3 rounded-lg"
              style={{ maxWidth: '280px' }}
            >
              <source src={message.media_url} type={guessAudioMime(message.media_url)} />
              Tu navegador no puede reproducir este audio.
            </audio>
            <a
              href={message.media_url}
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center gap-1 text-xs font-montserrat transition-colors ${
                isOutbound 
                  ? 'text-white/80 hover:text-white' 
                  : 'text-brand-gold hover:text-brand-gold/80'
              }`}
            >
              <Download className="w-3 h-3" />
              Descargar audio
            </a>
            {message.content && (
              <div className={`mt-3 pt-3 text-sm font-montserrat ${
                isOutbound ? 'border-t border-white/20' : 'border-t border-slate-200'
              }`}>
                {message.content}
              </div>
            )}
          </div>
        ) : mediaType === 'image' ? (
          <div>
            <div className={`rounded-xl overflow-hidden mb-2 ${
              isOutbound ? 'bg-white/10' : 'bg-slate-100'
            }`}>
              <img
                src={message.media_url}
                alt="Imagen enviada"
                className="w-full h-auto block max-w-sm"
                onError={(e) => {
                  console.warn('Image failed to load:', message.media_url);
                  e.target.style.display = 'none';
                }}
              />
            </div>
            {message.content && (
              <div className="text-sm font-montserrat leading-relaxed">
                {message.content}
              </div>
            )}
          </div>
        ) : (
          <div className="text-sm leading-relaxed whitespace-pre-wrap font-montserrat">
            {message.content}
          </div>
        )}

        {/* Timestamp */}
        <div className={`
          flex justify-end mt-2 text-xs font-montserrat
          ${isOutbound ? 'text-white/70' : 'text-slate-500'}
        `}>
          {new Date(message.timestamp).toLocaleTimeString([], { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </div>
      </div>
    </div>
  );
}

export default MessageBubble;